import { createSlice } from "@reduxjs/toolkit";
import { getPartnerLogos } from "./_partnerAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const logoList = createSlice({
  name: "logoList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPartnerLogos.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getPartnerLogos.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getPartnerLogos.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
